import { useMemo, useState } from "react"

import type { AnyFilter } from "./filter"
import { FilterManager } from "./manager"
import { FilterSchema } from "./schemas"

interface useFilterManagerProps<TData> {
	filterSchema: FilterSchema<TData>
	filters: AnyFilter[]
	onFilterChange?: (filters: AnyFilter[]) => void
}

export const useFilterManager = <TData>(props: useFilterManagerProps<TData>) => {
	const { filterSchema, filters, onFilterChange } = props

	// Stable reference throughout entirety of component life
	// oxlint-disable-next-line react/hook-use-state
	const [filterManager] = useState(() => FilterManager.create({ schema: filterSchema, filters }))

	// TODO: Would be best to make FilterManager and Observable and hooks up a useEffect here to subscribe using the
	// onFiltersChange prop

	// Keep filters and schema in sync
	filterManager.setOnFilterChange(onFilterChange)
	filterManager.setFilters(filters)
	filterManager.setSchema(filterSchema)

	return filterManager
}

interface useFiltersProps<TData> {
	filters: AnyFilter[]
	filterManager: FilterManager<TData>
	data: TData[]
}

export const useFilters = <TData>(props: useFiltersProps<TData>) => {
	const { filters, filterManager, data } = props

	return useMemo(() => {
		return filterManager.applyFilters(filters, data)
	}, [data, filterManager, filters])
}
